import React, {Component} from 'react'
import {Accordion, Icon} from 'semantic-ui-react'
import {formatDate} from '../../cads/format-date'

class ExFactoryDateLogs extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {
      active: true
    }

    this.toggleAccordion = this.toggleAccordion.bind(this)
  }

  toggleAccordion() {
    this.setState({active: !this.state.active})
  }

  render() {
    let {cadId} = this.props
    let {active} = this.state
    let {logs} = (window.editVpoPage == null ? {logs: []} : window.editVpoPage)

    logs = logs.filter(log => log.changedAttributeName == "ex_factory" && log.cadId == cadId)

    return (
      <div style={{fontSize: '10px', border: '1px solid rgb(238,238,238)', paddingRight: '5px'}}>
        {
          logs.length == 0
          ?
          null
          :
          <Accordion>
            <Accordion.Title onClick={this.toggleAccordion} style={{fontWeight: 'bold'}}>
              <Icon name='dropdown' />
              Ex-Factory Changes ({logs.length})
            </Accordion.Title>
            <Accordion.Content active={active} style={{marginTop: '-15px'}}>
              <ul style={{paddingLeft: '23px'}}>
                {
                  logs.map((log) => {
                    return (
                      <li style={{whiteSpace: 'nowrap', letterSpacing: '-0.1px'}}>changed from {formatDate(log.oldValue)} to {formatDate(log.newValue)}</li>
                    )
                  })
                }
              </ul>
            </Accordion.Content>
          </Accordion>
        }
      </div>
    )
  }
}

export default ExFactoryDateLogs
